"use client";

import React from "react";
import { Building2, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
const institutions = [{
  name: "Brown University, Providence, RI USA"
}, {
  name: "Cambridge Research Systems Ltd., Kent UK"
}, {
  name: "Case Western Reserve University, Cleveland OH USA"
}, {
  name: "Cortech Solutions Inc., Wilmington, NC USA"
}, {
  name: "Dresden University of Technology, Dresden Germany"
}, {
  name: "Duke University, Durham, NC USA"
}, {
  name: "Electrical Geodesics Inc., Eugene, OR USA"
}, {
  name: "German Institute for International & Educational Research, Frankfurt am Main, Germany"
}, {
  name: "Harvard University, Cambridge, MA USA"
}, {
  name: "Indiana University, Bloomington, IN USA"
}, {
  name: "Kappametrics, Chantilly, NC USA"
}, {
  name: "Kennedy Krieger Institute, Baltimore, MD USA"
}, {
  name: "Massachusetts General Hospital, Boston, MA USA"
}, {
  name: "Mount Sinai School of Medicine, New York, NY USA"
}, {
  name: "National Institutes of Health –NIH/NIMH, Bethesda, MD USA"
}, {
  name: "Omneuron, Menlo Park, CA USA"
}, {
  name: "Oregon Health Sciences Center, Portland, OR USA"
}, {
  name: "Tamagawa University, Brain Science Institute Tokyo, Japan"
}, {
  name: "The Ohio State University, Columbus OH USA"
}, {
  name: "University of Caen, Caen France"
}, {
  name: "University of Georgia, Athens, Georgia USA"
}, {
  name: "University of London, UK"
}, {
  name: "Louisiana State University, Shreveport, LA USA"
}, {
  name: "University of California, Davis, CA USA"
}, {
  name: "University of California, Los Angeles, CA USA"
}, {
  name: "University of California, San Diego, CA USA"
}, {
  name: "University of Illinois, Chicago USA"
}, {
  name: "University of Rochester, NY USA"
}, {
  name: "University of Manitoba, Winnipeg Canada"
}, {
  name: "University of Vienna, Austria"
}, {
  name: "University of Tubingen, Germany"
}, {
  name: "University of Glasgow, Scotland UK"
}, {
  name: "Veterans Administration Medical Center, San Diego, CA USA"
}, {
  name: "Veterans Administration Medical Center, Providence, RI USA"
}, {
  name: "Veterans Administration Medical Center, Temple, TX USA"
}, {
  name: "Wake Forest University, Winston Salem, NC USA"
}, {
  name: "Wayne State University, Detroit, MI USA"
}, {
  name: "Wisconsin Institutes for Medical Research, Madison, WI USA"
}];
export default function InstitutionsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="institutionsgrid" ref={ref} className={`bg-background py-16 md:py-24 lg:py-32 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-start">
          
          {}
          <div className="lg:col-span-4 xl:col-span-3 lg:sticky lg:top-32 flex flex-col gap-6">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 text-primary mb-2">
              <Building2 className="w-6 h-6" />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-default font-bold text-primary tracking-tight mb-4">
                NoMoCo Institutions
              </h2>
              <Separator className="w-12 h-1 bg-primary mb-6" />
              <p className="text-lg font-default text-foreground leading-relaxed">The following is a list of the institutions worldwide that have made the NoMoCo’s pillow support system their method of minimizing motion and enhancing subject comfort.</p>
            </div>
          </div>

          {}
          <div className="lg:col-span-8 xl:col-span-9">
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5">
              {institutions.map((inst, i) => <div key={i} data-index={i} className="group flex items-start gap-3 p-4 rounded-lg border border-border/60 bg-card/30 hover:bg-card/80 hover:border-border transition-all duration-300">
                  <MapPin className="w-4 h-4 text-primary/50 shrink-0 mt-0.5 group-hover:text-primary transition-colors" />
                  <span className="text-sm md:text-base font-default leading-snug group-hover:text-foreground transition-colors text-primary">
                    {inst.name}
                  </span>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}